import { readable } from 'svelte/store'
import { config } from '../config.js'
import { get } from '../services/http.js'

export let productTypes = readable([], function start(set) {
  let url = `${config.apiUrl}/product_types`
  get(url, false).then((data) => {
    set(data)
  })
})

export let getAttributes = async function getAttributes(id) {
  let url = `${config.apiUrl}/product_types/${id}/attr`
  return await get(url, false) // does not need auth
}
